//import logo from './logo.svg';
//<img src={logo} className="App-logo" alt="logo" />

import './App.css';
import { Navigation } from './components/Navigation';

//Import for Router (Multipage)
import {
  HashRouter as Router,
  Route,
  Switch,
  //Link,
  Redirect
} from "react-router-dom";

//Pages
import HomePage from "./pages/index";
import NotFoundPage from "./pages/404";
import ColorToolPage from "./pages/ColorTool";
import UsagePage from "./pages/Usage";



function App() {
  return (
    <Router>
      <Navigation />
      <Switch>
        {/*<Route exact path="/" component={HomePage} />*/}
        <Route exact path="/" component={ColorToolPage} />
        <Route exact path="/usage" component={UsagePage} />
        <Route exact path="/404" component={NotFoundPage} />
        {/* <Route path="" component={ } /> */}
        <Redirect to="/404"/>
      </Switch>
    </Router>
  );
}

export default App;